import React from 'react';

export function BlackMargin({ children }: { children: React.ReactNode }) {
  return <div className='d-flex-nowrap justify-content-center no-gutters bg-dark'>{children}</div>;
}

export function CenterMargin({ children }: { children: React.ReactNode }) {
  return <div className='d-flex-nowrap justify-content-center no-gutters'>{children}</div>;
}
